var map = {
	"./views/pc/NewsView.vue": [
		4200,
		958,
		720,
		200
	],
	"./views/pc/a/NewsView.vue": [
		5678,
		958,
		720,
		590,
		678
	],
	"./views/sp/NewsView.vue": [
		7121,
		958,
		720,
		121
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5323;
module.exports = webpackAsyncContext;